module.exports = __webpack_public_path__ + "static/green-light-f7e9756b545a20f0c61fc56b7e3a9f7f.png";